import styled from 'styled-components'
import { ContentHeader } from '../../../App'
import Item from '../Components/Item'
import { useContext, useEffect, useRef, useState } from 'react'
import { OrderItemsContext, OrderDataContext, MenuGroupsContext, MenuContext } from "../Context/WaiterContext"
import Heading from '../Heading'
import Api from "../../../api/api";
import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Box,
} from '@chakra-ui/react'

const HEADER_HEIGHT = 60;

function Second ({ page }) {
    const { orderItems, setOrderItems } = useContext(OrderItemsContext);
    const { menu } = useContext(MenuContext)
    const { menuGroups } = useContext(MenuGroupsContext)


    const [activeIndex, setActiveIndex] = useState(null);
    const accordionRefs = useRef([]);

    useEffect(() => {
        if (activeIndex !== null && accordionRefs.current[activeIndex]) {
            const element = accordionRefs.current[activeIndex];
            const rect = element.getBoundingClientRect();
            const isInView = rect.top >= HEADER_HEIGHT && rect.bottom <= window.innerHeight;

            if (!isInView) {
                window.scrollTo({
                    top: window.scrollY + rect.top - HEADER_HEIGHT,
                    behavior: 'smooth',
                });
            }
        }
    }, [activeIndex]);

    const handleAccordionChange = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    const addOrderItem = (item) => {
        if (item.id in orderItems) {
            setOrderItems((prev) => ({
                ...prev,
                [item.id]: {
                    ...prev[item.id],
                    quantity: prev[item.id].quantity + 1,
                    children: prev[item.id].children,
                },
            }));
        } else {
            setOrderItems((prev) => ({
                ...prev,
                [item.id]: {
                    quantity: 1,
                    children: {},
                },
            }));
        }
        let itemAdded = item.title;
        if (item.parent_id) {
            itemAdded = menu.find((menuItem => menuItem.id === item.parent_id)).title + ' ' + item.title;
        }

        Api.notify({
            text: 'Add item',
            data: {
                item: itemAdded,
            }
        });
    }

    const updateOrderItemChildren = (item, child, index, type) => {
        const tempOrderItems = { ...orderItems };
        if (!tempOrderItems[item.id]?.children) {
            tempOrderItems[item.id].children = [];
        }

        if (!tempOrderItems[item.id].children[index]) {
            tempOrderItems[item.id].children[index] = {};
        }

        if (type === 'remove') {
            if (!tempOrderItems[item.id].children[index][child.id]) {
                tempOrderItems[item.id].children[index][child.id] = {
                    quantity: 0,
                    price: child.price,
                    title: child.title,
                    description: child.description,
                };
            } else {
                tempOrderItems[item.id].children[index][child.id].quantity -= 1;
            }
            if (tempOrderItems[item.id].children[index][child.id].quantity <= 0) {
                delete tempOrderItems[item.id].children[index][child.id];
            }
        } else {
            if (!tempOrderItems[item.id].children[index][child.id]) {
                tempOrderItems[item.id].children[index][child.id] = {
                    quantity: 1,
                    price: child.price,
                    title: child.title,
                    description: child.description,
                };
            } else {
                tempOrderItems[item.id].children[index][child.id].quantity += 1;
            }
        }

        setOrderItems(tempOrderItems);
    }

    const removeOrderItem = (item) => {
        if (item.id in orderItems) {
            if (orderItems[item.id].quantity <= 1) {
                setOrderItems(current => {
                    const temp = { ...current }
                    delete temp[item.id]
                    return temp
                });
            } else {
                const tempOrderItems = { ...orderItems };

                tempOrderItems[item.id].quantity -= 1;

                if (tempOrderItems[item.id].children[tempOrderItems[item.id].quantity]) {
                    delete tempOrderItems[item.id].children[tempOrderItems[item.id].quantity];
                }

                setOrderItems(tempOrderItems);
            }

            let itemRemoved = item.title;
            if (item.parent_id) {
                itemRemoved = menu.find((menuItem => menuItem.id === item.parent_id)).title + ' ' + item.title;
            }
            Api.notify({
                text: 'Remove item',
                data: {
                    item: itemRemoved,
                }
            });
        }
    }

    return (
        <Wrapper>
            <ContentHeader>
                <Heading page={page} />
            </ContentHeader>
            <Accordion allowToggle mt={4} defaultIndex={[0]} reduceMotion index={activeIndex}>
                {menuGroups.map((group, index) =>
                    <AccordionItem key={index} ref={(el) => (accordionRefs.current[index] = el)}>
                        <h2>
                            <AccordionButton
                                background="#3F4041"
                                color="white"
                                _hover={{ color: "#AE996F" }}
                                onClick={() => handleAccordionChange(index)}
                            >
                                <Box as="span" flex='1' textAlign='left'>
                                    {group.name}
                                </Box>
                                <AccordionIcon />
                            </AccordionButton>
                        </h2>
                        <AccordionPanel pb={4} px={0}>
                            {menu.map(item => item.group_id === group.id &&
                                <Item
                                    key={item.id}
                                    item={item}
                                    childs={item.children ?? []}
                                    orderItems={orderItems}
                                    addOrderItem={addOrderItem}
                                    removeOrderItem={removeOrderItem}
                                    updateOrderItemChildren={updateOrderItemChildren}
                                />

                            )}
                        </AccordionPanel>
                    </AccordionItem>
                )}
            </Accordion>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    flex: 1;
    flex-direction: column;
`;

const Items = styled.div`

`

const GroupTitleWrapper = styled.div`
    position: relative;
    height: 30px;
    // margin: 20px 0 10px 0;
    background: #fff;
`

const GroupTitle = styled.div`
    text-align: center;
    text-transform: uppercase;
    color: #AE996F;
    line-height: 25px;

    .sticky {
        position: fixed;
        top: 50px;
        left: 0;
        right: 0;
    }

    span {
        display: inline-block;
        background: #fff;
        padding: 0 10px;
        font-size: 10px;
        z-index: 1;
        position: relative;
    }

    &:after {
        content: "";
        position: absolute;
        display: block;
        height: 1px;
        background: #AE996F;
        left: 10px;
        right: 10px;
        top: 13px;
        opacity: 0.3;
    }
`

const Notice = styled.span`
    font-size: 14px;
    opacity: 0.6;
    display: block;
    margin-top: 5px;
`

export default Second;
